

/** ref：https://juejin.cn/post/6955368971478499367
* 注意會缺失部份節點! 避免循環導致無法輸出Json 的問題，但注意會缺失部份節點，不要拿來存檔，只拿來 DEBUG。
*/
export function debug_json_strinify(object: object) {
  let cache: any[] = [];
  let str = JSON.stringify(object, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // 移除
        return;
      }
      // 收集所有的值
      cache.push(value);
    }
    return value;
  }, 4);

  return str;
}